import _ from 'lodash'
import { ModuleGridType } from 'types/global'
import { formatNumber } from '../../common/helpers'
import type { BasicAccessorConfig } from './types'

const setter = ({ moduleGrid, value }: { moduleGrid: ModuleGridType; value: number }) => {
  window.editor.execute(
    new window.SetPanelConfigurationCommand(
      moduleGrid,
      'roll',
      value,
      window.Utils.generateCommandUUIDOrUseGlobal()
    )
  )
}

const getter = (moduleGrid: ModuleGridType): number => {
  if (typeof (moduleGrid as any).getRoll === 'function') {
    return formatNumber((moduleGrid as any).getRoll())
  }
  return _.isNumber((moduleGrid as any).roll) ? formatNumber((moduleGrid as any).roll) : 0
}

export const rollAccessorConfig: BasicAccessorConfig<number> = {
  get: getter,
  set: setter,
}
